const { MediaQuery } = window.Foundation;
(() => {
  MediaQuery._init();
  let resized = false;
  let firstColLastNavIdx;

  const smallDownFormatting = (footerNavItems) => {
    const initialPixelsToLeft = footerNavItems[0].getBoundingClientRect().left;
    const marginBottom = parseFloat(getComputedStyle(footerNavItems[0]).marginBottom);
    if (resized) {
      footerNavItems[footerNavItems.length - 1].style.marginTop = `0`;
    }
    const lastColLastNavPos = footerNavItems[footerNavItems.length - 1].getBoundingClientRect().top;
    let isOneCol = true;
    let firstColLastNavPos;
    for (let i = 0; i < footerNavItems.length; i++) {
      if (footerNavItems[i].getBoundingClientRect().left > initialPixelsToLeft) {
        firstColLastNavPos = footerNavItems[i - 1].getBoundingClientRect().top;
        firstColLastNavIdx = i - 1;
        isOneCol = false;
        break;
      }
    }
    if (isOneCol) {
      return;
    }
    let offset = Math.round(firstColLastNavPos - lastColLastNavPos);
    let isNegative = offset < 0;
    offset = Math.abs(offset) + marginBottom;

    if (offset === 0 || offset > marginBottom * 1.75) {
      return;
    }
    if (isNegative) {
      footerNavItems[firstColLastNavIdx].style.marginTop = `${offset}px`;
    } else {
      footerNavItems[footerNavItems.length - 1].style.marginTop = `${offset}px`;
    }
    resized = true;
  };

  const resetMargins = (footerNavItems) => {
    if (footerNavItems[footerNavItems.length - 1].style.marginTop != 0) {
      footerNavItems[footerNavItems.length - 1].style.marginTop = "0";
    }
    if (firstColLastNavIdx && footerNavItems[firstColLastNavIdx].style.marginTop != 0) {
      footerNavItems[firstColLastNavIdx].style.marginTop = "0";
    }
  };

  const alignFooter = () => {
    const footerNavItems = document.querySelectorAll(".block__footerMid > ul > li");
    if (footerNavItems.length === 0) {
      return;
    }
    if (MediaQuery.is("small down")) {
      smallDownFormatting(footerNavItems);
    } else {
      resetMargins(footerNavItems);
      if (MediaQuery.atLeast("large")) {
        
      } else {
        
      }
    }
  };
  alignFooter();
  window.addEventListener("resize", alignFooter);
})();
